module.exports = __webpack_public_path__ + "static/media/noimage-white.aa4a49eb.svg";